import { useEffect, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { TableTitleBox } from '../../common/components';
import { useSalePoints } from '../../hooks/useSalePoints';
import LastInvoiceFilters from './components/LastInvoiceFilters';
import LastInvoiceDetails from './components/LastInvoiceDetails';
import { useLastInvoice } from './hooks/useLastInvoice';

const DEFAULT_VOUCHER_TYPE = 6;

const LastInvoiceTable = () => {
  const { data: salePoints = [], isLoading: loadingSalePoints } = useSalePoints();
  const [salePoint, setSalePoint] = useState('');
  const [voucherType, setVoucherType] = useState(DEFAULT_VOUCHER_TYPE);
  const [localError, setLocalError] = useState('');

  useEffect(() => {
    if (!salePoint && salePoints.length) {
      setSalePoint(salePoints[0].number);
    }
  }, [salePoints, salePoint]);

  const {
    data,
    error,
    isFetching,
    isLoading,
    refetch,
  } = useLastInvoice({ salePointNumber: salePoint, voucherType }, { enabled: false });

  const apiError = useMemo(() => {
    if (!error) return '';
    if (error.response?.data?.error) return error.response.data.error;
    if (error.message) return error.message;
    return 'Error desconocido';
  }, [error]);

  const handleSearch = () => {
    if (!salePoint) {
      setLocalError('Seleccioná un punto de venta');
      return;
    }
    setLocalError('');
    refetch();
  };

  const loadingState = isFetching || isLoading || loadingSalePoints;

  return (
    <>
      <TableTitleBox title="Habitat 99 | Registrar | Última factura AFIP" />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <LastInvoiceFilters
          salePoints={salePoints}
          salePoint={salePoint}
          setSalePoint={setSalePoint}
          voucherType={voucherType}
          setVoucherType={setVoucherType}
          onSearch={handleSearch}
          isLoading={loadingState}
        />
        {localError && (
          <Typography sx={{ color: '#d32f2f' }}>{localError}</Typography>
        )}
        <LastInvoiceDetails
          data={data}
          errorMessage={!localError ? apiError : ''}
          isLoading={isFetching || isLoading}
        />
      </Box>
    </>
  );
};

export default LastInvoiceTable;
